<template>
  <div class="more">
    <q-bar class="bg-white">
      <div class="col text-center">{{ $t('more.title') }}</div>
    </q-bar>
    <q-list bordered separator>
      <q-item
        v-for="item in items"
        :key="item.key"
        v-ripple
        clickable
        @click="goDetail(item)"
      >
        <q-item-section avatar>
          <q-icon color="primary" :name="`img:/icons/${item.key}.svg`" />
        </q-item-section>
        <q-item-section>
          <q-item-label> {{ $t(item.key) }} </q-item-label>
        </q-item-section>
        <q-item-section side>
          <i class="fas fa-chevron-right"></i>
        </q-item-section>
      </q-item>
    </q-list>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';

export default {
  name: 'MoreIndex',
  data() {
    return {
      items: [],
    };
  },
  created() {
    this.getMoreList()
      .then((res) => {
        this.items = res;
      })
      .catch((err) => {
        console.log(err);

        this.$notify.create({
          message: this.$t('more.getList.failed'),
          caption: err.response.data,
          position: 'top',
          type: 'negative',
        });
      });
  },
  methods: {
    ...mapActions({
      getMoreList: 'more/getMoreList',
      getMoreDetail: 'more/getMoreDetail',
    }),

    ...mapMutations({
      setCurrentMore: 'more/SET_CURRENT_MORE',
    }),

    async goDetail(item) {
      const routeName = item?.routeName ?? 'MoreDetail';

      try {
        switch (routeName) {
          case 'MoreChatHistory':
          case 'MoreLanguage':
            this.setCurrentMore(item);
            break;

          default: {
            const res = await this.getMoreDetail({
              aboutId: item.id,
              languageCode: this.$i18n.locale,
            });
            this.setCurrentMore({ ...item, ...res.data });
            break;
          }
        }

        this.$router.push({ name: routeName });
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
